export default __webpack_public_path__ + "static/media/carolmalaquini.a44bef31.jpg";